var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import ScoresMewsCardAPI from './scores-mews-card-api';
import React, { Component } from 'react';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import clinicalNotesImage from '../../assets/images/global/clinical-notes-40x40.svg';
import { ReactComponent as PendingIcon } from '../../assets/images/global/time.svg';
import { ReactComponent as ReleasedIcon } from '../../assets/images/global/check.svg';
import './scores-mews-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { DateFormatterUtil } from '../../utils';
const legends = [
    {
        color: 'signal-green-60',
        icon: React.createElement(ReleasedIcon, null),
        label: MessageService.translate('text.finished'),
        value: MessageService.translate('text.finished')
    },
    {
        color: 'signal-orange-45',
        icon: React.createElement(PendingIcon, null),
        label: MessageService.translate('tws.label-pending'),
        value: MessageService.translate('tws.label-pending')
    },
    {
        color: 'signal-green-60',
        icon: React.createElement(ReleasedIcon, null),
        label: MessageService.translate('tws.punctuation-0-2'),
        value: MessageService.translate('tws.punctuation-0-2')
    },
    {
        color: 'signal-yellow-60',
        icon: React.createElement(ReleasedIcon, null),
        label: MessageService.translate('tws.punctuation-3'),
        value: MessageService.translate('tws.punctuation-3')
    },
    {
        color: 'signal-orange-60',
        icon: React.createElement(ReleasedIcon, null),
        label: MessageService.translate('tws.punctuation-4'),
        value: MessageService.translate('tws.punctuation-4')
    },
    {
        color: 'signal-red-60',
        icon: React.createElement(ReleasedIcon, null),
        label: MessageService.translate('tws.punctuation-5'),
        value: MessageService.translate('tws.punctuation-5')
    }
];
let ScoresMewsCard = class ScoresMewsCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { dateEvaluation, idScoreIndexes, onClick, professional, status, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        dateEvaluation,
                        idScoreIndexes,
                        professional,
                        status,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    getStatusIcon() {
        const { status } = this.props;
        if (status?.toUpperCase() === 'A') {
            return React.createElement(ReleasedIcon, { className: 'c-scores-and-indexes-card__color-green' });
        }
        return React.createElement(PendingIcon, { className: 'c-scores-and-indexes-card__color-orange' });
    }
    renderStatus() {
        return (React.createElement("div", { className: 'c-scores-and-indexes-card__status' }, this.getStatusIcon()));
    }
    renderIndicatorColorStatus() {
        const { status } = this.props;
        if (status?.toUpperCase() === 'A') {
            return React.createElement("div", { className: 'c-scores-and-indexes-card__indicator-color-green' });
        }
        return React.createElement("div", { className: 'c-scores-and-indexes-card__indicator-color-orange' });
    }
    renderIndicator() {
        return (React.createElement("div", { className: 'c-scores-and-indexes-card__indicator' }, this.renderIndicatorColorStatus()));
    }
    renderAvatar() {
        const { professional, dateEvaluation } = this.props;
        const renderData = DateFormatterUtil.short(String(dateEvaluation));
        return (React.createElement("div", { className: 'c-scores-and-indexes-card__cn-avatar' },
            this.renderStatus(),
            React.createElement(Avatar, { image: clinicalNotesImage, title: renderData, subtitle: professional }),
            this.renderQtPunctuation()));
    }
    renderQtPunctuation() {
        const { qtPunctuation } = this.props;
        return (React.createElement("div", { className: "c-scores-and-indexes-card__punctuation" },
            React.createElement("p", { className: 'c-scores-and-indexes-card__text' }, `${MessageService.translate('tws.qt-punctuation')}`),
            React.createElement("span", { className: 'c-scores-and-indexes-card__qt-punctuation', style: this.renderScores(qtPunctuation) }, qtPunctuation)));
    }
    renderScores(qtPunctuation) {
        switch (true) {
            case qtPunctuation <= 2:
                return { background: 'hsl(var(--color-signal-green-60))', color: 'hsl(var(--color-white))' };
            case qtPunctuation === 3:
                return { background: 'hsl(var(--color-signal-yellow-60))', color: 'hsl(var(--color-black))' };
            case qtPunctuation === 4:
                return { background: 'hsl(var(--color-signal-orange-60))', color: 'hsl(var(--color-black))' };
            case qtPunctuation >= 5:
                return { background: 'hsl(var(--color-signal-red-60))', color: 'hsl(var(--color-white))' };
            default:
                return { background: '', color: '' };
        }
    }
    render() {
        return (React.createElement(Card, { className: 'c-scores-mews', selectionType: SelectionType.SINGLE, superscription: legends, width: 12, onClick: this.handleClick, uuid: generateUUID() },
            this.renderIndicator(),
            React.createElement("div", { className: 'c-scores-and-indexes-card__cn-wrapper', onClick: () => this.handleClick() }, this.renderAvatar())));
    }
};
ScoresMewsCard = __decorate([
    AwesomeComponent({ api: ScoresMewsCardAPI, type: ComponentType.DATA_DISPLAY })
], ScoresMewsCard);
export default ScoresMewsCard;
//# sourceMappingURL=scores-mews-card.js.map